import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditMapPage } from './edit-map.page';

const routes: Routes = [
  { path: '', component: EditMapPage }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditMapRoutingModule { }
